import React from 'react';
import { Grid, List, ListItem, ListItemText, Divider, Button, Slide, Hidden } from '@material-ui/core';
import WsC from './providers/WsC';
import PropTypes from 'prop-types';
import Utils from '../../providers/Utils';
import styled, { keyframes, css } from 'styled-components'
import { flash, zoomOut, rubberBand } from 'react-animations'
import { setTimeout } from 'timers';
import DialogSubIntrebare from './DialogSubIntrebare';
import { ReactComponent as TrashAltSolid } from './Icoane Font Awesome/trash-alt-solid.svg'
import { ReactComponent as CogSolid } from './Icoane Font Awesome/cog-solid.svg';

const flashS = keyframes`
    ${flash}
`;

const headS = keyframes`
    ${rubberBand}
`;

const zoomO = keyframes`
    ${zoomOut}
`;

const animateZoom = props => css`${zoomO} 0.5s`;

const animate = props => css`${flashS} ${props.animationLength}`;

const headA = props => css`${headS} 1s`;

const HeadShake = styled.div`animation:${props => props.Active ? headA : ''}`;



// const FadeOutLeft = styled.div`animation: 3s ${keyframes`${fadeOutLeft}`}`;
// const FadeOutRight = styled.div`animation: 3s ${keyframes`${fadeOutRight}`}`;

const Flash = styled.div`animation:${props => props.Active ? animate : ''}`;
const Zoom = styled.div`animation:${props => props.Active ? animateZoom : ''}`;

export default class ListaIntrebariChestionare extends React.Component {
    constructor(props) {
        super(props);
        this.raspunsuriInsert = React.createRef();
        this.state = {
            raspunsuri: [],
            intrebareToAnimate: null,
            intrebariChildren: []

        }
    }

    componentDidMount() {
        this.getRaspunsuri()
    }

    schimbaPozitie = (v, n) => {

        //   console.log('SchimbaPozitie :');
        let newList = this.props.listaIntrebari.map((el, k) => {
            switch (k) {
                case v: return this.props.listaIntrebari[n];
                case n: return this.props.listaIntrebari[v];
                default: return el;
            }
        })

        this.props.pozitieNoua(newList)


    }



    mutaSus = (idx) => {

        //  console.log('mutasus :', idx);
        // muta sus, e o schimbare de indecsi cu cel de mai sus
        if (idx > 0) {
            this.schimbaPozitie(idx, idx - 1)
        }


        //this.scrollLista('s')

        //this.calculeazaSchimbari()
    }




    mutaJos = (idx) => {

        // console.log('mutaJos :', idx);
        // muta jos, e o schimbare de indecsi cu cel de sub el
        if (idx < this.props.listaIntrebari.length - 1) {
            this.schimbaPozitie(idx, idx + 1)
        }
        //this.scrollLista('j')

        //this.calculeazaSchimbari()
    }

    getRaspunsuri = async (idIntrebare = null) => {

        // console.log('tempGets Here :', this.props.isIntrebariTemplate);



        let ws = new WsC();


        let getRaspunsuri;

        let idIntrebari = new Set(this.props.listaIntrebari.map(i => i.id))
        idIntrebari = [...idIntrebari]

        //  console.log('idIntrebari iduri intrebari:', idIntrebari);




        if (idIntrebari.length > 0) {


            if (this.props.isIntrebariTemplate !== true) {



                getRaspunsuri = ws.customSelect(`select * from chestionare_intrebari_optiuni_raspuns where isnull(inactiv,0) != 1 order by id asc `, {
                    p1: '1'
                })
            }
            else {
                getRaspunsuri = ws.customSelect('select * from template_chestionare_intrebari_optiuni_raspuns where isnull(inactiv,0) != 1 order by id asc', {
                    p1: '1'
                })
            }


            let getIntrebariChildren = ws.customSelect(`select * from chestionare_intrebari where id_parent in (${idIntrebari}) and isnull(inactiv,0) != 1 order by isnull(ordinea,0) asc, id `, {
                p1: '1'
            })


            let [r, iC] = await Promise.all([getRaspunsuri, getIntrebariChildren])

            console.warn('raspunsuri', r)
            console.warn('intrebari children', iC)

            if (r.Succes && iC.Succes) {


                //      console.warn('iC :', iC);

                let raspunsuri = [...r.Content]

                //   console.log('raspunsuri :', raspunsuri);


                for (let i = 0, n = raspunsuri.length; i < n; i++) {
                    raspunsuri[i].active = false
                }



                //   console.warn('this.props.listaIntrebari :', this.props.listaIntrebari);
                for (let i = 0, n = iC.Content.length; i < n; i++) {


                    let raspunsuriFilter = raspunsuri.filter(rasp => rasp.id_intrebare === iC.Content[i].id).map((m, idx) => {



                        return m.label
                    }).join(' - ')

                    raspunsuri.push({
                        id: iC.Content[i].id,
                        idx: i + 1,
                        id_intrebare_grupaj: iC.Content[i].id,
                        id_intrebare: iC.Content[i].id_parent,
                        id_grupaj: iC.Content[i].id_grupaj,
                        label: raspunsuriFilter,
                        label_rapoarte: null,
                        inactiv: 0,
                        img_src: null,
                        motivatie_raspuns: null
                    })


                }

                let cloneSubintrebari = [...iC.Content]

                for (let i = 0, n = cloneSubintrebari.length; i < n; i++) {
                    //  console.warn('enter looop')
                    let raspunsuriClone = raspunsuri.filter(r => r.id_intrebare === cloneSubintrebari[i].id)
                    //    console.warn('raspunsuri clone =-====', raspunsuriClone)
                    cloneSubintrebari[i].raspunsuri = raspunsuriClone
                }

                //  console.warn('raspunsuri :', raspunsuri);

                // console.log('r :', r);
                //         if(r.Succes && rTemp.Succes){

                //             let cloneRaspunsuri = [...r.Content]

                //             let counter = rTemp.Content.length


                //             for(let i = 0 ; i< counter; i++){
                //                 cloneRaspunsuri.push(rTemp.Content[i])

                //             }



                this.setState({
                    raspunsuri: raspunsuri,
                    intrebariChildren: cloneSubintrebari,
                    intrebareToAnimate: idIntrebare
                }, () => {
                    console.warn('this.state.objIntrebareInfo.id:', this.state.intrebareToAnimate)
                })

            }





        } else {

            //  console.warn('templates')
            if (this.props.isIntrebariTemplate !== true) {



                getRaspunsuri = await ws.customSelect(`select * from chestionare_intrebari_optiuni_raspuns where isnull(inactiv,0) != 1 order by id asc`, {
                    p1: '1'
                })
            }
            else {
                getRaspunsuri = await ws.customSelect('select * from template_chestionare_intrebari_optiuni_raspuns where isnull(inactiv,0) != 1 order by id asc', {
                    p1: '1'
                })
            }

            //  console.warn('getRaspunsuri :', getRaspunsuri);



            if (getRaspunsuri.Succes) {




                let raspunsuri = [...getRaspunsuri.Content]

                //   console.log('raspunsuri :', raspunsuri);


                for (let i = 0, n = raspunsuri.length; i < n; i++) {
                    raspunsuri[i].active = false
                }


                //  console.warn('raspunsuri :', raspunsuri);


                this.setState({
                    raspunsuri: raspunsuri,
                    intrebariChildren: [],
                    intrebareToAnimate: idIntrebare
                }, () => {

                })

            }

        }





    }

    changePuncte = (ev, r) => {
        let raspunsuri = [...this.state.raspunsuri]

        let idx = raspunsuri.findIndex(c => c.id === r.id)

        if (idx !== -1) {
            raspunsuri[idx].puncte = ev.target.value
        }

        this.setState({ raspunsuri: raspunsuri })

    }


    changeRaspuns = (ev, r) => {
        let raspunsuri = [...this.state.raspunsuri]

        let idx = raspunsuri.findIndex(c => c.id === r.id)

        if (idx !== -1) {
            raspunsuri[idx].label = ev.target.value
        }

        this.setState({ raspunsuri: raspunsuri })

    }

    deleteRaspuns = async (r) => {
        //  console.log('r :', r);

        // let raspunsToAnimate = document.getElementById(`animateraspuns${r.id}`)

        let raspunsuri = [...this.state.raspunsuri]


        let idx = raspunsuri.findIndex(c => c.id === r.id)

        if (idx !== -1) {
            raspunsuri[idx].active = true
        }

        this.setState({ raspunsuri: raspunsuri }, async () => {
            setTimeout(async () => {
                let ws = new WsC();


                let updateRaspuns = await ws.update('chestionare_intrebari_optiuni_raspuns', { inactiv: 1 }, { id: r.id })

                if (updateRaspuns.Succes) {
                    //    console.log('succesUpdate :', updateRaspuns);
                    this.getRaspunsuri()
                }
            }, 1000)

        })

        // console.log('raspunsToAnimate :', raspunsToAnimate);





    }
    render() {
        return (
            <div>
                <Grid container style={{
                    backgroundColor: this.props.backgroundColor,
                    borderRadius: 16,
                    position: 'relative',
                    width: '95%',
                    margin: 'auto',
                    marginBottom: 30,
                    marginTop: 0
                }}>

                    {/* {this.props.isTemplate !== true &&
                        <Fab style={{position:'absolute', top:6, right:10, display:this.props.displayFab === 1 ? 'none' : 'inline-flex'}}  onClick={this.props.openIntrebare} className="chestionare-adauga-button">
                                      <i className='material-icons chestionare-anuleaza-button-icon'>add</i>
                            </Fab>
                } */}

                    <div style={{ width: '100%', display: 'flex', flex: 1, justifyContent: 'space-between' }}>
                        <Button style={{ display: this.props.goBack === true ? 'inline-flex' : 'none' }} className='chestionare-appbar-buttons' onClick={this.props.goBackFunc} >
                            <i style={{ verticalAlign: 'bottom' }} className='material-icons'>keyboard_arrow_left</i>
                            <span className='chestionare-appbar-button-text'>Inapoi</span>
                        </Button>

                        <Button style={{ display: this.props.goBack === true ? 'inline-flex' : 'none' }} className='chestionare-appbar-buttons' onClick={this.props.importaChestionar} >
                            <i style={{ verticalAlign: 'bottom' }} className='material-icons'>keyboard_arrow_right</i>
                            <span className='chestionare-appbar-button-text'>Foloseste Chestionarul</span>
                        </Button>

                    </div>


                    <Grid item xs={12} sm={12} md={12} l={12} xl={12} className='chestionare-container-item'>

                        {/* <input disabled={this.props.isTemplate} style={{ fontSize: 21, width: '90%', textAlign: 'center', backgroundColor: 'transparent', color: this.props.titluChestionarColor }} className='chestionare-task-time-input' type='text' value={this.props.titluChestionar || " "} onChange={this.props.changeTitlu} onBlur={this.props.updateTitlu} /> */}

                        {this.props.showTabs &&

                            <div>


                                {/* <div style={{ border: '1px dashed white', maxWidth: 300, }} className='chestionare-add-chestionar-container' onDragOver={(ev) => { this.dragOver(ev) }} onDrop={(ev) => { this.drop(ev) }}>
                                    <p>Adauga intrebare folosind sageata </p>

                                    <i className='material-icons' style={{ position: 'absolute', left: 10, fontSize: 30, bottom: 0 }}>keyboard_arrow_right</i>
                                    <i className='material-icons' style={{ position: 'absolute', right: 10, fontSize: 30, bottom: 0 }}>keyboard_arrow_left</i>

                                </div> */}
                                {/* <div className='chestionare-add-chestionar-container' onClick={() => {
                                    this.props.addIntrebare() 
                                }} style={{
                                    // maxWidth: 160,
                                    width:'100%',
                                    fontSize: 20,
                                    cursor: 'pointer',
                                    backgroundColor: 'rgb(250,126,131)',
                                    padding: 3,
                                    verticalAlign: 'top',
                                    height: '100%',
                                    minHeight: 94
                                }} >
                                    <p> Click pentru o noua intrebare <i className='material-icons' style={{ verticalAlign: 'sub' }}>add</i></p>



                                </div> */}

                            </div>
                        }

                        <List  >
                            {
                                this.props.listaIntrebari.map((i, idx) => {
                                    return (

                                        <LiListaIntrebari displayFab={this.props.displayFab}
                                            preview={this.props.preview}
                                            left={this.props.left}
                                            key={'intrebare' + idx}
                                            intrebare={i}
                                            idx={idx}
                                            intrebariChildren={this.state.intrebariChildren.filter(int => int.id_parent === i.id)}
                                            openEdit={this.props.openEdit}
                                            count={this.props.listaIntrebari.length}
                                            mutaSus={this.mutaSus}
                                            mutaJos={this.mutaJos}
                                            onClick={this.props.goToIntrebare}
                                            isTemplate={this.props.isTemplate}
                                            raspunsuri={this.state.raspunsuri}
                                            dragStart={this.props.dragStart}
                                            moveToList={this.props.moveToList}
                                            deleteIntrebare={this.props.deleteIntrebare}
                                            changeIntrebare={this.props.changeIntrebare}
                                            changeRaspuns={this.changeRaspuns}
                                            getRaspunsuri={this.getRaspunsuri}
                                            deleteRaspuns={this.deleteRaspuns}
                                            intrebareToAnimate={this.state.intrebareToAnimate}
                                            folosestePuncte={this.props.folosestePuncte}
                                            changePuncte={this.changePuncte}
                                        />
                                    )
                                })
                            }
                        </List>

                    </Grid>
                </Grid>
            </div>
        );
    }
}


class LiListaIntrebari extends React.Component {
    constructor(props) {
        super(props);
        this.subIntrebare = React.createRef()
        this.textInput = React.createRef();
        this.state = {
            raspunsuri: [],
            isDrag: false,
            hideText: true,
            raspunsNou: 'Adauga Raspuns',
            fade: false,
            flashOn: false,
            zoomActive: false,
            isOpenSubintrebare: false,
            objIntrebareChild: { tip: '' }
        }

    }



    componentDidMount() {

    }

    focus = () => {
        this.setState({ hideText: false }, () => {
            this.textInput.current.focus()

        })


    }

    getInputRaspuns = (r, rasp, i = null) => {

        //   console.log('this.props.intrebare :', this.props.intrebare);

        if (this.props.intrebare.tip === 'grupaj') {
            //   console.log('grupaj :');

            //  console.log('raspuns :', rasp);

            let intrebareToAdd = {
                idx: rasp.idx,
                id: rasp.id_intrebare_grupaj,
                intrebare: this.props.intrebare.intrebare,
                id_parent: rasp.id_intrebare,
                id_grupaj: rasp.id_grupaj,
                id_categorie: 1,
                tip: 'radio'
            }

            //   console.log('intrebareToAdd :', intrebareToAdd);

            this.setState({
                isOpenSubintrebare: true,
                objIntrebareChild: intrebareToAdd
            }, () => {
                this.subIntrebare.current.getRaspunsuri()
            })

        }
        else if (this.props.intrebare.tip === 'subintrebare') {
            //   console.log('enterSubraspuns :');
            //   console.log('r :', r);
            //   console.log('rasp :', rasp);

            let intrebareToAdd = {
                idx: rasp.idx,
                id: rasp.id_intrebare_grupaj,
                intrebare: i.intrebare,
                id_parent: rasp.id_intrebare,
                id_grupaj: rasp.id_grupaj,
                motivatie_label: i.motivatie_label,
                id_categorie: 1,
                tip: i.tip
            }
            this.setState({
                isOpenSubintrebare: true,
                objIntrebareChild: intrebareToAdd
            }, () => {
                this.subIntrebare.current.getRaspunsuri()
            })
        }
        else {

            //   console.log('r :', r);
            let input = document.getElementById(r).focus();
        }




    }

    deleteRaspuns = async (r) => {
        //  console.log('r :', r);

        let ws = new WsC()

        let deleteRaspuns = await ws.update('chestionare_intrebari', { inactiv: 1 }, { id: r.id_intrebare_grupaj })

        if (deleteRaspuns.Succes) {
            this.props.getRaspunsuri()
        }
    }

    deleteSubintrebare = async (r) => {

        let ws = new WsC()
        //   console.warn('subintrebare :', r);
        let deleteRaspuns = await ws.update('chestionare_intrebari', { inactiv: 1 }, { id: r.id })

        if (deleteRaspuns.Succes) {
            this.props.getRaspunsuri()
        }
    }

    updateRaspuns = async (r) => {
        // console.log('r :', r);

        let ws = new WsC();

        let updateRaspuns = await ws.update('chestionare_intrebari_optiuni_raspuns', { label: r.label, puncte: r.puncte || 0 }, { id: r.id })

        if (updateRaspuns.Succes) {
            //   console.log('succesUpdate :', updateRaspuns);
        }
    }



    insertRaspuns = async () => {
        // console.log('raspuns nou :', this.state.raspunsNou);

        let ws = new WsC();

        if (this.props.intrebare.tip !== 'grupaj') {
            if (this.props.intrebare.tip === 'subintrebare') {


                // let intrebare = this.props.intrebare
                let u = new Utils()

                let intrebareToAdd = {
                    id_chestionar: this.props.intrebare.id_chestionar,
                    intrebare: this.props.nume,
                    id_parent: this.props.intrebare.id,
                    id_grupaj: u.generateId(),
                    id_categorie: 1,
                    tip: 'radio',
                }
                //   console.log('intrebare Parent:', intrebare);
                //  console.log('intrebareToAdd :', intrebareToAdd);

                let insert = await ws.insert('chestionare_intrebari', intrebareToAdd)

                //   console.log('insert :', insert);

                if (insert.Succes) {

                    intrebareToAdd.id = insert.Content[0].id



                    this.setState({
                        isOpenSubintrebare: true,
                        objIntrebareChild: intrebareToAdd
                    }, () => {
                        this.props.getRaspunsuri()
                    })
                }



            } else {
                let insert = await ws.insert('chestionare_intrebari_optiuni_raspuns', {
                    id_intrebare: this.props.intrebare.id,
                    label: this.state.raspunsNou,
                    puncte: 0,
                    tip: this.props.intrebare.tip
                })

                //  console.warn('insert :', insert);
                if (insert.Succes) {
                    if (!this.props.intrebare.tip.includes('img')) {
                        this.setState({ raspunsNou: 'Adauga raspuns' }, () => {
                            this.props.getRaspunsuri()

                        })
                    } else {

                        await this.props.getRaspunsuri()
                        this.selectFile(`file-poza-raspuns${insert.Content[0].id}`)
                    }


                }
            }


        } else {
            let intrebare = this.props.intrebare
            let u = new Utils()

            let intrebareToAdd = {
                intrebare: intrebare.intrebare,
                id_parent: intrebare.id,
                id_grupaj: u.generateId(),
                id_categorie: 1,
                tip: 'radio',
            }
            // console.log('intrebare Parent:', intrebare);
            // console.log('intrebareToAdd :', intrebareToAdd);

            let insert = await ws.insert('chestionare_intrebari', intrebareToAdd)

            // console.log('insert :', insert);

            if (insert.Succes) {

                intrebareToAdd.id = insert.Content[0].id

                this.setState({
                    isOpenSubintrebare: true,
                    objIntrebareChild: intrebareToAdd,

                }, () => {
                    this.props.getRaspunsuri()

                })
            }
        }


    }

    selectFile = (id) => {

        //  console.log('Incepe poza');

        // console.log('id :', id);
        let pi = document.getElementById(id);

        //  console.log('pi :', pi);

        pi.click()

    }

    uploadPoza = async (id, idRaspuns) => {


        let ws = new WsC();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);


        //  console.log('idRaspuns :', idRaspuns);



        reader.onload = async () => {
            // let fileContent = reader.result;
            //   console.log(fileContent);
            //  console.log('saveFile :', saveFile);


            let uploadImage = await ws.uploadimage('Upload/UpdatePozaRaspuns/?idRaspuns', saveFile, idRaspuns);

            // console.log('uploadImage :', uploadImage);
            if (uploadImage.Succes) {


                this.props.getRaspunsuri()

            }
            //console.log('uploadimage :', uploadImage);
            // console.log('uploadFileApiCall :', uploadFileApiCall);


        }
    }


    placeHolderRaspunsuri = (idx) =>{

        console.log('idx :>> ', idx);

        if(idx === 0){
            return 'Completeaza aici prima varianta de raspuns'
        }else if (idx === 1){
            return 'Completeaza aici a doua varianta de raspuns'
        }else{
            return `Completeaza aici a ${idx + 1}-a varianta de raspuns`
        }
    }



    filterRaspunsuri = () => {
        let cloneRaspunsuri = [...this.props.raspunsuri]

        let varianteRaspuns = cloneRaspunsuri.filter(r => r.id_intrebare === this.props.intrebare.id)

        console.log('varianteRaspuns :', varianteRaspuns);
        console.log('this.props.listaIntrebari :>> ', this.props.intrebariChildren);

        if (this.props.intrebare.tip.includes('img')) {
            return varianteRaspuns.map((r, idx) => {
                if (r.img_src !== null) {
                    return (

                        <span style={{ marginLeft: 10, display: 'block', position: 'relative', width: '100%', marginBottom: 10 }} key={'raspuns' + idx}>

                            <Flash animationLength='0.5s' Active={r.active} id={`animateraspuns${r.id}`}>

                                <Grid container>
                                    <Grid item xs={11} sm={11} md={11} lg={11} xl={11} >
                                        <Grid container>
                                            <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                                                {new Utils().alfabet[idx]})
                        <img alt={r.img_src} style={{ maxWidth: 50, verticalAlign: 'middle' }} src={new WsC().adresaMedia + `/Chestionare/Raspunsuri_img/${r.img_src}`} />
                                                <input type='file' id={`file-poza-raspuns${r.id}`}
                                                    style={{ display: 'none' }}
                                                    accept='image/*'
                                                    onChange={() => { this.uploadPoza(`file-poza-raspuns${r.id}`, r.id) }}
                                                />
                                            </Grid>

                                            <Grid item xs={2} sm={2} md={2} lg={2} xl={2} >
                                                {this.props.isTemplate ?
                                                    <span style={{
                                                        color: 'rgba(0, 0, 0, 0.87)',
                                                        fontSize: 15,
                                                    }}>
                                                        {r.puncte || 0}
                                                    </span>

                                                    :

                                                    <div style={{ position: 'relative', display: 'inline', width: '100%' }}>
                                                        <input
                                                            disabled={this.props.isTemplate || this.props.intrebare.tip === 'grupaj'}
                                                            style={{
                                                                width: '80%',
                                                                textAlign: 'left',
                                                                color: 'rgba(0, 0, 0, 0.87)',
                                                                textOverflow: 'ellipsis',
                                                                lineHeight: 1,

                                                                margin: 0,
                                                                fontSize: 15,
                                                                fontFamily: 'inherit',
                                                                verticalAlign: 'text-top',

                                                                padding: 10
                                                            }}
                                                            id={`raspunspuncte${r.id}`}
                                                            onFocus={(e) => {
                                                                var val = e.target.value;
                                                                e.target.value = '';
                                                                e.target.value = val;
                                                            }}
                                                            className='add-project-input'
                                                            placeholder={0}
                                                            type='text'
                                                            value={r.puncte || ""}
                                                            onChange={(ev) => { this.props.changePuncte(ev, r) }}
                                                            onBlur={() => { this.updateRaspuns(r) }} />
                                                        <label className='inputLabelPM' htmlFor={`raspunspuncte${r.id}`}>Puncte</label>
                                                    </div>
                                                }
                                            </Grid>


                                        </Grid>
                                    </Grid>
                                    {!this.props.isTemplate && this.props.intrebare.tip !== 'grupaj' &&
                                        <Grid item xs={1} sm={1} md={1} lg={1} xl={1} >

                                            <i style={{ marginRight: 10, fontSize: 20 }} onClick={() => { this.selectFile(`file-poza-raspuns${r.id}`) }} className="material-icons iconFontSize textSecondary">edit</i>
                                            <TrashAltSolid className='textSecondary' onClick={() => { this.props.deleteRaspuns(r) }} style={{ marginRight: 0, width: 18, height: 18 }} />

                                            {/* <i onClick={() => { this.props.intrebare.tip !== 'grupaj' ? this.props.deleteRaspuns(r) : this.deleteRaspuns(r) }} style={{ marginRight: 0, }} className="material-icons iconFontSize textSecondary">delete</i> */}

                                        </Grid>
                                    }

                                </Grid>





                            </Flash>
                        </span>
                    )
                } else {
                    return (

                        <span style={{ marginLeft: 10, display: 'block', position: 'relative', width: '100%', marginBottom: 10 }} key={'raspuns' + idx}>
                            <Flash animationLength='0.5s' Active={r.active} id={`animateraspuns${r.id}`}>

                                <Grid container>
                                    <Grid item xs={11} sm={11} md={11} lg={11} xl={11} >
                                        <Grid container>
                                            <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                                                {new Utils().alfabet[idx]})  <i style={{ verticalAlign: 'middle' }} className='material-icons'>image</i>
                                                <input type='file' id={`file-poza-raspuns${r.id}`}
                                                    style={{ display: 'none' }}
                                                    accept='image/*'
                                                    onChange={() => { this.uploadPoza(`file-poza-raspuns${r.id}`, r.id) }}
                                                />
                                            </Grid>

                                            <Grid item xs={2} sm={2} md={2} lg={2} xl={2} >
                                                {this.props.isTemplate ?
                                                    <span style={{
                                                        color: 'rgba(0, 0, 0, 0.87)',
                                                        fontSize: 15,
                                                    }}>
                                                        {r.puncte || 0}
                                                    </span>

                                                    :

                                                    <div style={{ position: 'relative', display: 'inline', width: '100%' }}>
                                                        <input
                                                            disabled={this.props.isTemplate || this.props.intrebare.tip === 'grupaj'}
                                                            style={{
                                                                width: '80%',
                                                                textAlign: 'left',
                                                                color: 'rgba(0, 0, 0, 0.87)',
                                                                textOverflow: 'ellipsis',
                                                                lineHeight: 1,

                                                                margin: 0,
                                                                fontSize: 15,
                                                                fontFamily: 'inherit',
                                                                verticalAlign: 'text-top',

                                                                padding: 10
                                                            }}
                                                            id={`raspunspuncte${r.id}`}
                                                            onFocus={(e) => {
                                                                var val = e.target.value;
                                                                e.target.value = '';
                                                                e.target.value = val;
                                                            }}
                                                            className='add-project-input'
                                                            placeholder={0}
                                                            type='text'
                                                            value={r.puncte || ""}
                                                            onChange={(ev) => { this.props.changePuncte(ev, r) }}
                                                            onBlur={() => { this.updateRaspuns(r) }} />
                                                        <label className='inputLabelPM' htmlFor={`raspunspuncte${r.id}`}>Puncte</label>
                                                    </div>
                                                }
                                            </Grid>


                                        </Grid>

                                    </Grid>

                                    {!this.props.isTemplate && this.props.intrebare.tip !== 'grupaj' &&
                                        <Grid item xs={1} sm={1} md={1} lg={1} xl={1} >

                                            <i style={{ marginRight: 10, fontSize: 20 }} onClick={() => { this.selectFile(`file-poza-raspuns${r.id}`) }} className="material-icons iconFontSize textSecondary">edit</i>
                                            <TrashAltSolid className='textSecondary' onClick={() => { this.props.deleteRaspuns(r) }} style={{ marginRight: 0, width: 18, height: 18 }} />

                                            {/* <i onClick={() => { this.props.intrebare.tip !== 'grupaj' ? this.props.deleteRaspuns(r) : this.deleteRaspuns(r) }} style={{ marginRight: 0, }} className="material-icons iconFontSize textSecondary">delete</i> */}

                                        </Grid>
                                    }
                                </Grid>


                            </Flash>
                        </span>
                    )

                }
            })

        }
        else if (this.props.intrebare.tip === 'grupaj') {
            return this.props.intrebariChildren.map((r, idx) => {
                return (

                    <span style={{ marginLeft: 5, display: 'block', position: 'relative', width: '100%', marginBottom: 10, }} key={'raspuns' + idx} >
                        <Flash animationLength='0.5s' Active={r.active} id={`animateraspuns${r.id}`}>
                            {/* <span style={{display:this.state.hideText ? 'inline-block' : 'none', wordBreak:'break-all', width:'90%'}} >{r.label}</span>    */}
                            <Grid container>
                                <Grid item xs={10} sm={10} md={10} lg={10} xl={10} >
                                    {new Utils().alfabet[idx]}) <span style={{ fontWeight: 600 }}>{r.intrebare}</span>

                                    <span style={{
                                        color: 'rgba(0, 0, 0, 0.87)',
                                        fontSize: 15,
                                    }}>
                                        {r.raspunsuri.map((rg, idx4) => {
                                            return (<span style={{ display: 'block', marginLeft: 20 }} key={idx4}>{idx4 + 1}. {rg.label} </span>)
                                        })}
                                    </span>


                                </Grid>

                                {this.props.folosestePuncte &&
                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2} >
                                        {this.props.isTemplate ?
                                            <span style={{
                                                color: 'rgba(0, 0, 0, 0.87)',
                                                fontSize: 15,
                                            }}>
                                                {r.puncte || '0'}
                                            </span>

                                            :

                                            <input
                                                disabled={this.props.isTemplate || this.props.intrebare.tip === 'grupaj'}
                                                style={{
                                                    width: '62%',
                                                    textAlign: 'left',
                                                    backgroundColor: 'transparent',
                                                    color: 'rgba(0, 0, 0, 0.87)',
                                                    textOverflow: 'ellipsis',
                                                    lineHeight: 1,

                                                    margin: 0,
                                                    fontSize: 15,
                                                    fontFamily: 'inherit',
                                                    verticalAlign: 'text-top',

                                                    padding: 0
                                                }}
                                                id={`raspunspuncte${r.id}`}
                                                onFocus={(e) => {
                                                    var val = e.target.value;
                                                    e.target.value = '';
                                                    e.target.value = val;
                                                }}
                                                className='chestionare-task-time-input'
                                                placeholder={0}
                                                type='text'
                                                value={r.puncte || ""}
                                                onChange={(ev) => { this.props.changePuncte(ev, r) }}
                                                onBlur={() => { this.updateRaspuns(r) }} />
                                        }
                                    </Grid>
                                }


                            </Grid>





                            {!this.props.isTemplate && this.props.intrebare.tip !== 'grupaj' &&
                                <span style={{ position: 'absolute', top: 0, right: -24, padding: '0 20px 0 0' }}>
                                    <i style={{ marginRight: 10, fontSize: 18 }} onClick={() => { this.getInputRaspuns(`raspuns${r.id}`, r) }} className="material-icons iconFontSize textSecondary">edit</i>
                                    <TrashAltSolid className='textSecondary iconSvg' onClick={() => { this.props.intrebare.tip !== 'grupaj' ? this.props.deleteRaspuns(r) : this.deleteRaspuns(r) }} style={{ marginRight: 0, width: 18, height: 18 }} />

                                    {/* <i onClick={() => { this.props.intrebare.tip !== 'grupaj' ? this.props.deleteRaspuns(r) : this.deleteRaspuns(r) }} style={{ marginRight: 0, }} className="material-icons iconFontSize textSecondary">delete</i> */}
                                </span>
                            }
                        </Flash>
                    </span>



                )
            })
        }
        else {


            return varianteRaspuns.map((r, idx) => {
                return (

                    <span style={{ marginLeft: 5, display: 'block', position: 'relative', width: '100%', marginBottom: 10, }} key={'raspuns' + idx} >
                        <Flash animationLength='0.5s' Active={r.active} id={`animateraspuns${r.id}`}>
                            {/* <span style={{display:this.state.hideText ? 'inline-block' : 'none', wordBreak:'break-all', width:'90%'}} >{r.label}</span>    */}
                            <Grid container>
                                <Grid item xs={11} sm={11} md={11} lg={11} xl={11} >
                                    <Grid container>
                                        <Grid item xs={10} sm={10} md={10} lg={10} xl={10} >
                                            <span style={{ verticalAlign: 'sub' }}>{new Utils().alfabet[idx]})</span>
                                            {this.props.isTemplate ?
                                                <span style={{
                                                    color: 'rgba(0, 0, 0, 0.87)',
                                                    fontSize: 15,
                                                }}>
                                                    {r.label}
                                                </span>

                                                :
                                                <div style={{ position: 'relative', display: 'inline', marginLeft: 20, width: '100%' }}>
                                                    <input
                                                        disabled={this.props.isTemplate || this.props.intrebare.tip === 'grupaj'}
                                                        style={{
                                                            width: '90%',
                                                            textAlign: 'left',
                                                            color: 'rgba(0, 0, 0, 0.87)',
                                                            textOverflow: 'ellipsis',
                                                            lineHeight: 1,

                                                            margin: 0,
                                                            fontSize: 15,
                                                            fontFamily: 'inherit',
                                                            verticalAlign: 'text-top',

                                                            padding: 10
                                                        }}
                                                        id={`raspuns${r.id}`}
                                                        // onFocus={(e) => {
                                                        //     var val = e.target.value;
                                                        //     e.target.value = '';
                                                        //     e.target.value = val;
                                                        className='add-project-input'
                                                        type='text'
                                                        placeholder={this.placeHolderRaspunsuri(idx)}
                                                        value={r.label || ""}
                                                        onChange={(ev) => { this.props.changeRaspuns(ev, r) }}
                                                        onBlur={() => { this.updateRaspuns(r) }} />
                                                    <label className='inputLabelPM' htmlFor={`raspuns${r.id}`}>Raspuns</label>
                                                </div>

                                            }


                                        </Grid>


                                        <Grid item xs={2} sm={2} md={2} lg={2} xl={2} >
                                            {this.props.isTemplate ?
                                                <span style={{
                                                    color: 'rgba(0, 0, 0, 0.87)',
                                                    fontSize: 15,
                                                }}>
                                                    {r.puncte || '0'}
                                                </span>

                                                :
                                                <div style={{ position: 'relative', display: 'inline', width: '100%' }}>
                                                    <input
                                                        disabled={this.props.isTemplate || this.props.intrebare.tip === 'grupaj'}
                                                        style={{
                                                            width: '80%',
                                                            textAlign: 'left',
                                                            color: 'rgba(0, 0, 0, 0.87)',
                                                            textOverflow: 'ellipsis',
                                                            lineHeight: 1,

                                                            margin: 0,
                                                            fontSize: 15,
                                                            fontFamily: 'inherit',
                                                            verticalAlign: 'text-top',

                                                            padding: 10
                                                        }}
                                                        id={`raspunspuncte${r.id}`}
                                                        onFocus={(e) => {
                                                            var val = e.target.value;
                                                            e.target.value = '';
                                                            e.target.value = val;
                                                        }}
                                                        className='add-project-input'
                                                        placeholder={0}
                                                        type='text'
                                                        value={r.puncte || ""}
                                                        onChange={(ev) => { this.props.changePuncte(ev, r) }}
                                                        onBlur={() => { this.updateRaspuns(r) }} />
                                                    <label className='inputLabelPM' htmlFor={`raspunspuncte${r.id}`}>Puncte</label>
                                                </div>
                                            }
                                        </Grid>

                                    </Grid>
                                </Grid>

                                {!this.props.isTemplate && this.props.intrebare.tip !== 'grupaj' &&
                                    <Grid item xs={1} sm={1} md={1} lg={1} xl={1} >

                                        <i style={{ marginRight: 10, fontSize: 18 }} onClick={() => { this.getInputRaspuns(`raspuns${r.id}`, r) }} className="material-icons iconFontSize textSecondary">edit</i>
                                        <TrashAltSolid className='textSecondary iconSvg' onClick={() => { this.props.intrebare.tip !== 'grupaj' ? this.props.deleteRaspuns(r) : this.deleteRaspuns(r) }} style={{ marginRight: 0, width: 18, height: 18 }} />

                                        {/* <i onClick={() => { this.props.intrebare.tip !== 'grupaj' ? this.props.deleteRaspuns(r) : this.deleteRaspuns(r) }} style={{ marginRight: 0, }} className="material-icons iconFontSize textSecondary">delete</i> */}

                                    </Grid>
                                }


                            </Grid>






                        </Flash>
                    </span>



                )
            })
        }


    }

    getInfoIntrebare = () => {
        this.props.onClick(this.props.intrebare)

    }

    deleteIntrebare = () => {
        this.props.delete(this.props.intrebare)
    }

    mutaSus = () => {
        this.props.mutaSus(this.props.idx)
    }
    mutaJos = () => {
        this.props.mutaJos(this.props.idx)
    }

    updateIntrebare = async () => {
        // console.log('intrebareToUpdate :', this.props.intrebare);

        let ws = new WsC();

        let updateIntrebare = await ws.update('chestionare_intrebari', { intrebare: this.props.intrebare.intrebare }, { id: this.props.intrebare.id })

        if (updateIntrebare.Succes) {
            this.setState({ hideText: true })
            //   console.log('succesUpdate :', updateIntrebare);
        }
    }

    moveToList = () => {
        this.setState({ fade: true }, () => {
            this.props.moveToList(this.props.intrebare)
        })

        setTimeout(() => {
            this.setState({ fade: false })
        }, 1000)
    }


    deleteIntrebare = () => {

        this.setState({ zoomActive: true }, () => {
            setTimeout(() => {
                this.props.deleteIntrebare(this.props.intrebare)
            }, 400)
        })

    }

    getChestionar = () => {
        //  console.log('getChestionar :');
    }

    updateSubintrebare = async () => {

        let objSubintrebare = {
            intrebare: this.state.objIntrebareChild.intrebare,
            tip: this.state.objIntrebareChild.tip,
            motivatie_label: this.state.objIntrebareChild.motivatie_label
        }

        let ws = new WsC()

        let subUpdate = await ws.update('chestionare_intrebari', objSubintrebare, { id: this.state.objIntrebareChild.id })

        if (subUpdate.Succes) {
            this.props.getRaspunsuri()
        }

    }

    changeSubintrebareTitle = (ev) => {
        let subIntrebare = { ...this.state.objIntrebareChild }

        subIntrebare.intrebare = ev.target.value

        this.setState({ objIntrebareChild: subIntrebare })
    }

    motivatieChange = (ev) => {
        let subIntrebare = { ...this.state.objIntrebareChild }

        subIntrebare.motivatie_label = ev.target.value

        this.setState({ objIntrebareChild: subIntrebare })
    }


    render() {
        return (
            <div>
                {this.props.isTemplate !== true &&
                    <div >
                        <DialogSubIntrebare
                            open={this.state.isOpenSubintrebare}
                            dialogClose={() => { this.setState({ isOpenSubintrebare: false }) }}
                            getRaspunsuri={this.props.getRaspunsuri}
                            getChestionar={this.getChestionar}
                            objIntrebareInfo={this.state.objIntrebareChild}
                            updateIntrebare={this.updateSubintrebare}
                            objIntrebareParent={this.props.intrebare}
                            numeChange={this.changeSubintrebareTitle}
                            motivatieChange={this.motivatieChange}
                            title={this.props.intrebare.intrebare}
                            ref={this.subIntrebare}
                        />
                        <HeadShake Active={this.props.intrebare.id === this.props.intrebareToAnimate ? true : false} >
                            <Zoom Active={this.state.zoomActive}>
                                {/* <div style={{ textAlign: 'right', marginTop: 10, marginBottom: 10 }}>
                                    <Button className='chestionare-main-button' onClick={() => { this.props.openEdit(this.props.intrebare) }} >
                                        Editeaza Suplimentar
                                    </Button>
                                </div> */}

                                <ListItem button style={{ display: 'block', width: '100%' }}>

                                    {/* <i onClick={this.mutaSus} className='material-icons' style={{
                                        color: '#16ac48',
                                        cursor: 'pointer',
                                        position: 'absolute',
                                        left: -5,
                                        fontSize: 34,
                                        visibility: this.props.displayFab !== 1 ? (this.props.idx === 0 ? 'hidden' : 'visible') : 'hidden'
                                    }}>keyboard_arrow_up</i> */}

                                    <h3 style={{ paddingLeft: 0, position: 'relative', display: 'block', }} className='chestionare-list-text'>
                                        <Grid container>
                                            <Grid item xs={11} sm={11} md={11} lg={11} xl={11}>
                                                <span style={{ verticalAlign: 'top' }}> {this.props.idx + 1 + '.'}</span>
                                                {/* <span onClick={this.focus} style={{ display: this.state.hideText ? 'inline-block' : 'none', wordBreak: 'break-word', width: '90%' }} >{this.props.intrebare.intrebare}</span> */}
                                                <div style={{ position: 'relative', display: 'inline', marginLeft: 20, width: '100%' }}>
                                                    <textarea
                                                        id={`intrebare${this.props.idx}`}
                                                        disabled={this.props.isTemplate}
                                                        style={{
                                                            width: '90%',
                                                            textAlign: 'left',
                                                            color: 'rgba(108,108,108	)',
                                                            fontWeight: 'bold',
                                                            lineHeight: 1,
                                                            // display: this.state.hideText ? 'none' : 'inline',
                                                            margin: 0,
                                                            fontSize: 15,
                                                            fontFamily: 'inherit',
                                                            verticalAlign: 'text-top',

                                                            padding: '5px 0 0 10px'
                                                        }}
                                                        ref={this.textInput}
                                                        onFocus={(e) => {
                                                            var val = e.target.value;
                                                            e.target.value = '';
                                                            e.target.value = val;
                                                        }}
                                                        className='add-project-input'
                                                        type='text'
                                                        value={this.props.intrebare.intrebare || ""}
                                                        onChange={(ev) => { this.props.changeIntrebare(ev, this.props.intrebare) }}
                                                        placeholder='Completeaza aici intrebarea'
                                                        onBlur={this.updateIntrebare} >

                                                    </textarea>
                                                    <label className='inputLabelPM' htmlFor={`intrebare${this.props.idx}`}>Intrebare</label>

                                                </div>



                                            </Grid>
                                            {!this.props.isTemplate &&

                                                <Grid style={{ paddingTop: 10 }} item xs={1} sm={1} md={1} lg={1} xl={1}>
                                                    <TrashAltSolid className='textSecondary iconSvg' onClick={this.deleteIntrebare} style={{ marginRight: 0, width: 18, height: 18, }} />
                                                    <CogSolid className='textSecondary iconSvg' onClick={() => { this.props.openEdit(this.props.intrebare) }} style={{ marginLeft: 10, width: 18, height: 18, }} />

                                                </Grid>
                                            }



                                        </Grid>



                                    </h3>
                                    <span style={{ paddingLeft: this.props.idx === 0 ? 30 : 0, margin: 10 }} className='chestionare-list-subtext'>
                                        {this.props.intrebare.tip === 'text' ? 'Text Liber' : this.filterRaspunsuri()}



                                    </span>

                                    {/* <i onClick={this.mutaJos} className='material-icons' style={{
                                        color: '#16ac48',
                                        cursor: 'pointer',
                                        position: 'absolute',
                                        right: -10,
                                        fontSize: 34,
                                        visibility: this.props.displayFab !== 1 ? (this.props.count - 1 === this.props.idx ? 'hidden' : 'visible') : 'hidden'
                                    }}>keyboard_arrow_down</i> */}
                                </ListItem>
                            </Zoom>
                        </HeadShake>

                        {this.props.intrebare.tip !== 'text' &&
                            <Hidden lgUp>
                                <div >
                                    <Button style={{ width: '90%', marginBottom: 20 }} variant="contained" onClick={this.insertRaspuns} className='chestionare-adauga-raspuns-button'>
                                        {/* <i className='material-icons'>add_circle_outline</i>  */}
                                         Adauga Raspuns
                              </Button>

                                </div>
                            </Hidden>
                        }


                        {this.props.intrebare.tip !== 'text' &&
                            <Hidden mdDown>
                                <div style={{ textAlign: 'left', paddingLeft: 55 }}>
                                    <Button style={{ width: 'fit-content', marginBottom: 20, }} variant="contained" onClick={this.insertRaspuns} className='chestionare-adauga-raspuns-button'>
                                        {/* <i className='material-icons'>add_circle_outline</i>  */}
                                         Adauga Raspuns
                              </Button>

                                </div>
                            </Hidden>
                        }



                        <Divider className="crm-divider" />

                    </div>
                }
                {this.props.isTemplate === true &&
                    <div draggable onDragStart={() => { this.props.dragStart(this.props.intrebare) }}  >

                        <Slide direction="right" in={!this.state.fade} mountOnEnter unmountOnExit>
                            <ListItem >
                                {
                                    !this.props.left &&
                                    <i className="material-icons" onClick={this.moveToList} style={{ fontSize: 34, color: '#16ac48', display: this.props.preview ? 'none' : 'inline-block', cursor: 'pointer' }}>keyboard_arrow_left</i>
                                }
                                <ListItemText primary={<h3 className='chestionare-list-text'>

                                    {this.props.idx + 1 + '.'}    {this.props.intrebare.intrebare}
                                </h3>}

                                    secondary={<span className='chestionare-list-subtext'>
                                        {this.props.intrebare.tip === 'text' ? 'Text Liber' : this.filterRaspunsuri()}
                                    </span>}
                                />
                                {
                                    this.props.left &&
                                    <i className="material-icons" onClick={this.moveToList} style={{ fontSize: 34, color: '#16ac48', display: this.props.preview ? 'none' : 'inline-block', cursor: 'pointer' }}>keyboard_arrow_right</i>
                                }
                            </ListItem>
                        </Slide>
                        <Divider className="crm-divider" />
                    </div>
                }
            </div>
        )
    }
}


ListaIntrebariChestionare.propType = {
    listaIntrebari: PropTypes.array,
    pozitieNoua: PropTypes.func,
    isTemplate: PropTypes.bool,
    openIntrebare: PropTypes.func,
    goToIntrebare: PropTypes.func,
    dragStart: PropTypes.func,
    moveToList: PropTypes.func,
    deleteIntrebare: PropTypes.func,

};


LiListaIntrebari.propType = {
    raspunsuri: PropTypes.array,
    intrebare: PropTypes.object,
    idx: PropTypes.number,
    isTemplate: PropTypes.bool,
    dragStart: PropTypes.func,

}




